'use strict';

var jsxRuntime = require('react/jsx-runtime');

var e=jsxRuntime.jsxs("g",{viewBox:"0 0 36 36",fill:"none",children:[jsxRuntime.jsx("path",{d:"M11.6001 18.8L16.4001 23.6L24.4001 14",stroke:"currentColor",strokeWidth:"3",strokeLinecap:"round",strokeLinejoin:"round"}),jsxRuntime.jsx("path",{d:"M18 34C26.8366 34 34 26.8366 34 18C34 9.16344 26.8366 2 18 2C9.16344 2 2 9.16344 2 18C2 26.8366 9.16344 34 18 34Z",stroke:"currentColor",strokeWidth:"3"})]});

exports.IconSuccess = e;
